import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ACCESS_KEY = "ops_access";
const REFRESH_KEY = "ops_refresh";

export const tokenStore = {
    getAccess: () => localStorage.getItem(ACCESS_KEY),
    getRefresh: () => localStorage.getItem(REFRESH_KEY),
    set: (access, refresh) => {
        if (access) localStorage.setItem(ACCESS_KEY, access);
        if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    },
    clear: () => {
        localStorage.removeItem(ACCESS_KEY);
        localStorage.removeItem(REFRESH_KEY);
    },
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = tokenStore.getAccess();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

let refreshing = null;

function forceLogout() {
    tokenStore.clear();
    window.dispatchEvent(new Event("ops:logout"));
}

api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const { response, config } = error;
        if (!response || response.status !== 401 || !config || config.__retried) {
            return Promise.reject(error);
        }
        const url = config.url || "";
        if (url.includes("/auth/login") || url.includes("/auth/refresh")) {
            return Promise.reject(error);
        }
        const refresh = tokenStore.getRefresh();
        if (!refresh) {
            forceLogout();
            return Promise.reject(error);
        }
        try {
            if (!refreshing) {
                refreshing = axios
                    .post(`${API}/auth/refresh`, { refresh_token: refresh })
                    .then((r) => {
                        tokenStore.set(r.data.access_token, r.data.refresh_token);
                        return r.data.access_token;
                    })
                    .finally(() => {
                        refreshing = null;
                    });
            }
            const newAccess = await refreshing;
            config.__retried = true;
            config.headers.Authorization = `Bearer ${newAccess}`;
            return api(config);
        } catch (e) {
            forceLogout();
            return Promise.reject(e);
        }
    }
);

export default api;
